import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { formatMoney } from '../../../../util/currency';

import css from '../../OrderItemInfo.css';

const PromoDiscount = ({ discount, intl }) => {
  if (!discount || !discount.lineTotal.amount) return null;

  const { lineTotal, code, percentage, reversal } = discount;

  return (
    <p
      className={classNames(css.text, css.priceContainer)}
      key={reversal ? `${code}_1` : `${code}_0`}
    >
        <span className={css.productName}>
          <FormattedMessage id="OrderInfo.discount" />
          {percentage && <span>{` ${percentage}%`}</span>}
        </span>
      <span className={css.text}>{formatMoney(intl, lineTotal)}</span>
    </p>
  );
}

export default PromoDiscount;
